


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import _orderBy from 'lodash/orderBy'
import _filter from 'lodash/filter'

import BaseLogin from '@/components/common/BaseLogin.vue'
import BaseLink from '@/components/common/BaseLink.vue'

@Component( {
    components: {
        'oe-link': BaseLink,
        'oe-base-login': BaseLogin
    },
    computed: mapGetters( {
        commentsByAssociationId: 'commentsModule/commentsByAssociationId',
        formattedDate: 'globalModule/formattedDate',
        userById: 'usersModule/userById',
        currentUser: 'usersModule/currentUser',
        currentImage: 'imagesModule/currentImage'
    } )
} )
export default class BaseComments extends Vue {
    @Prop() associationId !: number | null
    createdComment = {
        associationId: this.associationId,
        contentRaw: '',
        infoOnUpdate: false
    }
    commentInputVisible = false
    emptyComment = false
    userNeedToLogIn = true
    commentsByAssociationId!: any
    currentUser!: any
    currentImage!: any

    get orderedComments() {
        return _orderBy( this.commentsByAssociationId( this.associationId ), 'dateCreated', ['asc'] )
    }

    get isExplorerStartView() {
        return this.$route.name === 'Associations' || this.$route.name === 'Users'
    }

    showCommentInput() {
        this.commentInputVisible = true
    }

    hideCommentInput() {
        this.commentInputVisible = false
        this.emptyComment = false
    }

    startExplorer() {
        this.$router.push( `/${this.$i18n.locale}/explorer?imageId=${this.currentImage.id}&associationId=${this.associationId}` )
    }

    sendComment() {
        let commentActionType = 'commentsModule/createLocalComment'

        if ( this.createdComment.contentRaw === '' ) {
            this.emptyComment = true
        } else {
            this.emptyComment = false

            if ( this.currentUser.isRegistered ) {
                commentActionType = 'commentsModule/createComment'
            }

            this.$store.dispatch( commentActionType, this.createdComment )
                .then( () => {
                    this.commentInputVisible = false
                    this.resetComment()
                } )
        }
    }

    resetComment() {
        this.createdComment = {
            associationId: this.associationId,
            contentRaw: '',
            infoOnUpdate: false
        }
    }

    discardComment() {
        this.userNeedToLogIn = false
        this.commentInputVisible = false
    }
}
